<template>
  <div v-if="currentProject">
    <div class="row">
      <div class="page-select col-md-3">
        <b-form-select v-model="currentView"
                       :options="viewOptions">
        </b-form-select>
      </div>
    </div>
    <baseline-explorer v-if="currentView == 'baseline-explorer'"></baseline-explorer>
    <baseline-comparison v-if="currentView == 'baseline-comparison'"></baseline-comparison>
  </div>
</template>

<script>
  import BaselineComparison from './BaselineComparison.vue'
  import BaselineExplorer from './BaselineExplorer.vue'
  import RequirementsDetail from './RequirementsDetail.vue'
  import ItemsList from './ItemsList.vue'
  export default {
    components: { BaselineComparison, BaselineExplorer, RequirementsDetail, ItemsList },
    computed: {
      currentProject () {
        return this.$store.state.currentProject
      },
      currentView: {
        get () {
          return this.$store.state.currentBaselinePage
        },
        set (value) {
          this.$store.commit('setCurrentBaselinePage', value)
        }
      }
    },
    data () {
      return {
        viewOptions: [
          {
            text: 'Baseline Explorer',
            value: 'baseline-explorer'
          },
          {
            text: 'Baseline Comparison',
            value: 'baseline-comparison'
          }
        ]
      }
    },
    watch: {
      currentView (newValue, oldValue) {
        console.log('CHANGED', oldValue, newValue)
        if (newValue !== oldValue) {
          let currentPage = window.AP.history.getState()
          if (newValue === 'baseline-explorer' && currentPage !== 'baselines') {
            window.AP.history.pushState(`${this.currentProject.id}-baselines`)
          } else if (newValue === 'baseline-comparison' && currentPage !== 'comparison') {
            window.AP.history.pushState(`${this.currentProject.id}-comparison`)
          }
        }
      }
    }
  }
</script>

<style>
  .page-select {
    margin: 15px;
  }
</style>



// WEBPACK FOOTER //
// BaselineView.vue?131d1411